import { Link, router } from "@inertiajs/react"
import { AppLayout } from "@/layouts/AppLayout"
import { formatDate } from "@/utils/helpers"
import type { Source } from "@/types/models"

interface Props {
  sources: Source[]
}

export default function SourcesIndex({ sources }: Props) {
  function handleDelete(source: Source) {
    if (confirm("Delete this source?")) {
      router.delete(`/admin/sources/${source.id}`)
    }
  }

  return (
    <AppLayout title="Sources">
      <main className="admin-sources space-y-6">
        <header className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-slate-900">Sources</h1>
          <Link
            href="/admin/sources/new"
            className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            New Source
          </Link>
        </header>

        {sources.length > 0 ? (
          <div className="overflow-x-auto rounded-lg bg-white shadow-sm ring-1 ring-slate-200">
            <table className="w-full text-left text-sm">
              <thead className="border-b border-slate-200 bg-slate-50 text-xs uppercase text-slate-500">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Host</th>
                  <th className="px-4 py-3">Backend</th>
                  <th className="px-4 py-3">Mode</th>
                  <th className="px-4 py-3">Active</th>
                  <th className="px-4 py-3">Last Crawled</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {sources.map((source) => (
                  <tr key={source.id}>
                    <td className="px-4 py-3 font-medium text-slate-900">
                      {source.name}
                    </td>
                    <td className="px-4 py-3 text-slate-600">{source.host}</td>
                    <td className="px-4 py-3 text-slate-600">
                      {source.extractionBackend}
                    </td>
                    <td className="px-4 py-3 text-slate-600">
                      {source.extractionMode}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
                          source.active
                            ? "bg-green-100 text-green-700"
                            : "bg-slate-100 text-slate-600"
                        }`}
                      >
                        {source.active ? "Yes" : "No"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-slate-500">
                      {formatDate(source.lastCrawledAt)}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <Link
                          href={`/admin/sources/${source.id}/edit`}
                          className="text-sm text-slate-600 hover:text-slate-900"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() => handleDelete(source)}
                          className="text-sm text-red-600 hover:text-red-900"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="rounded-lg bg-white p-6 text-slate-500 shadow-sm ring-1 ring-slate-200">
            No sources configured yet.
          </p>
        )}
      </main>
    </AppLayout>
  )
}
